import React, { Suspense, useState } from 'react'
import { useQuery } from 'react-query'
import { superFetch } from 'commons'

const ONE_DAY = 86400000

const emptyReferentiel = {
  ListeTypeContrat: [],
  ListeEnergie: [],
  ListeDevise: [],
  ListePays: [],
  ListeDelaiPaiement: [],
  ListeTypeLot: [],
  ListeHorosaisonnier: [],
  ListeFormulePrix: [],
  ListeIat: [],
  ListeTypeDeConso: [],
  ListCHRPas: [],
  ListDesUnites: [],
  ListTypeFormatCsv: [],
  ListValidationStatus: []
}

export const useReferentiel = () => {

  const query = useQuery(
    'referentiel',
    () => superFetch({ url: 'referentiel/contrat' }),
    async () => {
      const response = await superFetch({ url: 'referentiel/contrat' });      

      if (response && typeof response.json === 'function') {
        return await response.json();
      }
      return response; 
    },
    {
      staleTime: ONE_DAY,
      select: (data) => {
        if (!data) return emptyReferentiel;
        
        const transformed = {};
      
        Object.keys(data).forEach((key) => {
          const list = data[key];
          if (Array.isArray(list)) {
            transformed[key] = list.map((item) => ({
              value: item.Id ?? item.id, 
              label: item.Nom ?? item.nom,
            }));
          } else {
            transformed[key] = [];
          }
        });

        return transformed;
      },
    }
  );
    
  const formattedData = query.data || emptyReferentiel;

  return { 
    ...formattedData, 
    isLoading: query.isLoading,
    status: query.status 
  };
}
